import styled from 'styled-components';
import { Text, Icon, useThemeColor, Box } from '@wistia/vhs';
import { isNotNil } from '~/utilities/type-guards';
import type { ReactNode, JSX } from 'react';

const ImageContainer = styled.div`
  img {
    border-radius: 8px;
    vertical-align: bottom;
    width: 100%;
  }
`;

const StyledText = styled(Text)`
  align-items: center;
  display: flex;
`;

type TooltipContentProps = {
  image?: JSX.Element;
  content?: ReactNode;
  upgradeText?: string;
  title?: JSX.Element | string;
};

export const TooltipContent = ({
  image,
  content,
  upgradeText,
  title,
}: TooltipContentProps): JSX.Element => {
  const [grey900, purple600] = useThemeColor(['grey900', 'purple600']);

  return (
    <Box
      direction="column"
      gap="8px"
    >
      {isNotNil(image) ? (
        <ImageContainer data-testid="tooltip-image">{image}</ImageContainer>
      ) : null}
      {isNotNil(title) ? (
        <Text
          colorOverride={grey900}
          data-testid="tooltip-title"
          variant="headline3"
        >
          {title}
        </Text>
      ) : null}
      {isNotNil(upgradeText) ? (
        <StyledText
          colorOverride={purple600}
          data-testid="tooltip-upgrade"
          variant="overline"
        >
          <Icon
            size="md"
            style={{ marginRight: '8px' }}
            type="sparkle"
          />
          {upgradeText}
        </StyledText>
      ) : null}
      <Text
        colorOverride={grey900}
        variant="body1"
      >
        {content}
      </Text>
    </Box>
  );
};
